import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";

const COLORS = { Completed: "#059669", Cancelled: "#DC2626", "No-Show": "#F59E0B" };

const SchedulingDonut = ({ completedVsScheduledPct = 0, cancellationRatePct = 0, noShowRatePct = 0 }) => {
  const slices = [
    { name: "Completed", value: completedVsScheduledPct },
    { name: "Cancelled", value: cancellationRatePct },
    { name: "No-Show",   value: noShowRatePct },
  ].filter(s => s.value > 0);

  if (!slices.length) return (
    <div style={{ padding: "32px", textAlign: "center", color: "#9CA3AF", fontSize: "14px" }}>No data available</div>
  );

  const renderLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    if (percent < 0.06) return null;
    const rad = (midAngle * Math.PI) / 180;
    const r = innerRadius + (outerRadius - innerRadius) * 0.5;
    return (
      <text
        x={cx + r * Math.cos(-rad)}
        y={cy + r * Math.sin(-rad)}
        fill="#fff" textAnchor="middle" dominantBaseline="central" fontSize={12} fontWeight="600"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <ResponsiveContainer width="100%" height={240}>
      <PieChart>
        <Pie
          data={slices} cx="50%" cy="50%" innerRadius={60} outerRadius={100} dataKey="value"
          labelLine={false} label={renderLabel} isAnimationActive animationDuration={600}
        >
          {slices.map(s => <Cell key={s.name} fill={COLORS[s.name] || "#CBD5E1"} />)}
        </Pie>
        <Tooltip
          formatter={v => [`${v}%`, ""]}
          contentStyle={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: "8px", fontSize: "12px" }}
        />
        <Legend wrapperStyle={{ fontSize: "12px", color: "#6B7280" }} />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default SchedulingDonut;
